import { IResourceComponentsProps } from "@pankod/refine-core"

export const CustomizableContentEdit: React.FC<IResourceComponentsProps> = () => {
    return (
        <></>
    )
}